// extracted by mini-css-extract-plugin
export default {"menuBlock":"gE-z","title":"hE-z","nav":"iE-z","flexCell":"jE-z","facetLink":"kE-z"};